import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import axios from 'api/axios';
import Login from './Login.js';
const PASSWORD_RESET_URL = 'users/password/reset_link';

const RenewPassword = () => {

  // CHECK SECURITY
  const navigate = useNavigate();

  const location = useLocation();
  const from = location.state?.from?.pathname || '/renouvelerMotDePasse/confirmation';

  const errRef = useRef();
  const userRef = useRef();

  const [user, setUser] = useState('');
  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    userRef.current.focus();
  }, [])

  useEffect(() => {
    setErrMsg('');
  }, [user])

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(PASSWORD_RESET_URL,
        JSON.stringify({ email: user }),
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      setUser('');
      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username');
      } else if (err.response?.status === 401) {
        setErrMsg('Invalid Username');
      } else if (err.response?.status === 422) {
        setErrMsg('Invalid Username');
      } else {
        setErrMsg('Server Failed');
      }
      errRef.current.focus();
    }
  }

  return (
    <Login>
      <div className="Login-formulaire">
        <form onSubmit={handleSubmit}>
          <div ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</div>
          <p className="Login-info">
            Veuillez saisir votre adresse e-mail ci-dessous pour recevoir un e-mail contenant les instructions de réinitialisation du mot de passe.
          </p>

          <div className="Login-field identifier"><span>*</span> Email</div>
          <Input
            required
            value={user}
            inputRef={userRef}
            id="Login-identifier"
            disableUnderline={true}
            className="Login-input identifier"
            onChange={(e) => setUser(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <MailOutlineIcon fontSize="small" style={{ color: '#326ea0' }} />
              </InputAdornment>
            }
          />
          <button className="Login-rectangle-button" onSubmit={handleSubmit}>Réinitialiser le mot de passe</button>
        </form>
      </div>
    </Login>
  );
}

export default RenewPassword;
